import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MHSocialMediaService from "../../services/MHSocialMediaService";
import facebook from "../../assets/facebook.svg";
import instagram from "../../assets/instagram.svg";
import twitter from "../../assets/x.svg";
import youtube from "../../assets/youtube.svg";
import snap from "../../assets/snapchat.svg";
import tiktok from "../../assets/tiktok.svg";
import logo from "../../assets/MasterHN-white.svg";
import "./style.css";

const Footer = () => {
	const [data, setData] = useState({
		facebook: "",
		instagram: "",
		twitter: "",
		youtube: "",
		snapchat: "",
		you_tube: "",
		qr_code: "",
	});
	const { t } = useTranslation();
	const mHSocialMediaService = new MHSocialMediaService();

	useEffect(() => {
		mHSocialMediaService.getList().then((res) => {
			if (res?.status === 200 && !!res?.data?.data) {
				setData(res?.data?.data);
			}
		});
	}, []);

	return (
		<footer className="mt-5">
			<div className="custom-div">
				<div className="row">
					<div className="col-md-3 col-12">
						<img src={logo} className="mb-4" alt="logo" width={250} />
						<div className="icons">
							{!!data?.facebook && (
								<a rel="noreferrer" href={data.facebook} target="_blank">
									<img src={facebook} alt="facebook" />
								</a>
							)}
							{!!data?.instagram && (
								<a rel="noreferrer" href={data?.instagram} target="_blank">
									<img src={instagram} alt="instagram" />
								</a>
							)}
							{!!data?.twitter && (
								<a rel="noreferrer" href={data.twitter} target="_blank">
									<img src={twitter} alt="x" />
								</a>
							)}
							{!!data?.you_tube && (
								<a rel="noreferrer" href={data?.you_tube} target="_blank">
									<img src={youtube} alt="youtube" />
								</a>
							)}
							{!!data?.snapchat && (
								<a rel="noreferrer" href={data?.snapchat} target="_blank">
									<img src={snap} alt="snap" />
								</a>
							)}
							{!!data?.tiktok && (
								<a rel="noreferrer" href={data?.tiktok} target="_blank">
									<img src={tiktok} alt="tiktok" />
								</a>
							)}
						</div>
					</div>
					<div className="col-md-2 web-view"></div>
					<div className="col-md-2 col-12">
						{/* <h4>{t("quick_links")}</h4> */}
						<div className="links">
							<NavLink
								to="/"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("home")}
							</NavLink>
							<NavLink
								to="/categories"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("categories")}
							</NavLink>
							<NavLink
								to="/products"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("products")}
							</NavLink>
							<NavLink
								to="/style-up"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("Design")}
							</NavLink>
							<NavLink
								to="/about-us"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("about-us")}
							</NavLink>
							<NavLink
								to="/contact"
								className={({ isActive }) => (isActive ? "active" : "")}
								aria-current="page">
								{t("contact")}
							</NavLink>
						</div>
					</div>
					<div className="col-md-2 web-view"></div>
					<div className="col-md-3 three col-12">
						{data?.address && (
							<div>
								<svg
									width="40"
									height="40"
									viewBox="0 0 40 40"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect width="40" height="40" rx="20" fill="white" />
									<path
										d="M19.375 27.6875C14.8125 21.125 14 20.4375 14 18C14 14.6875 16.6562 12 20 12C23.3125 12 26 14.6875 26 18C26 20.4375 25.1562 21.125 20.5937 27.6875C20.3125 28.125 19.6562 28.125 19.375 27.6875ZM20 20.5C21.375 20.5 22.5 19.4063 22.5 18C22.5 16.625 21.375 15.5 20 15.5C18.5937 15.5 17.5 16.625 17.5 18C17.5 19.4063 18.5937 20.5 20 20.5Z"
										fill="#2D9495"
									/>
								</svg>
								<span>{data?.address}</span>
							</div>
						)}
						{data?.gmail && (
							<div>
								<svg
									width="40"
									height="40"
									viewBox="0 0 40 40"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect width="40" height="40" rx="20" fill="white" />
									<path
										d="M27.6875 17.9688C27.8125 17.875 28 17.9688 28 18.125V24.5C28 25.3438 27.3125 26 26.5 26H13.5C12.6562 26 12 25.3438 12 24.5V18.125C12 17.9688 12.1562 17.875 12.2812 17.9688C13 18.5313 13.9062 19.2188 17.0937 21.5313C17.75 22 18.875 23.0313 20 23.0313C21.0937 23.0313 22.25 22 22.875 21.5313C26.0625 19.2188 26.9687 18.5313 27.6875 17.9688ZM20 22C19.25 22.0313 18.2187 21.0938 17.6875 20.7188C13.5312 17.7188 13.2187 17.4375 12.2812 16.6875C12.0937 16.5625 12 16.3438 12 16.0938V15.5C12 14.6875 12.6562 14 13.5 14H26.5C27.3125 14 28 14.6875 28 15.5V16.0938C28 16.3438 27.875 16.5625 27.6875 16.6875C26.75 17.4375 26.4375 17.7188 22.2812 20.7188C21.75 21.0938 20.7187 22.0313 20 22Z"
										fill="#2D9495"
									/>
								</svg>
								<span>{data?.gmail}</span>
							</div>
						)}
						{data?.call_us && (
							<div>
								<svg
									width="40"
									height="40"
									viewBox="0 0 40 40"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect width="40" height="40" rx="20" fill="white" />
									<path
										d="M27.4062 12.7813C27.75 12.875 28 13.1563 28 13.5C28 21.5313 21.5 28 13.5 28C13.125 28 12.8437 27.7812 12.75 27.4375L12 24.1875C11.9375 23.8438 12.0937 23.4688 12.4375 23.3125L15.9375 21.8125C16.25 21.6875 16.5937 21.7813 16.8125 22.0313L18.375 23.9375C20.8125 22.7813 22.7812 20.7813 23.9062 18.4063L22 16.8438C21.75 16.625 21.6562 16.2813 21.7812 15.9688L23.2812 12.4688C23.4375 12.125 23.8125 11.9375 24.1562 12.0313L27.4062 12.7813Z"
										fill="#2D9495"
									/>
								</svg>

								<span>{data?.call_us}</span>
							</div>
						)}
					</div>
				</div>
				<hr />

				<div className="power-sec d-flex justify-content-between">
					<p className="power">
						{t("Powered By")}:{" "}
						<a href="https://teknulugy.com" target="_blank" rel="noreferrer">
							Teknulugy
						</a>
					</p>
					{/* <div className="d-flex" style={{ gap: "22px" }}>
						<Link>{t("Privacy Policy")}</Link>
						<Link>{t("Terms & Condition")}</Link>
					</div> */}
				</div>
			</div>
		</footer>
	);
};
export default Footer;
